<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" >
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="拣货单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>拣货单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="库房" v-if="getIsView()">
                <el-input disabled v-model="form.warehouseName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>库房:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="创建人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>创建人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdTime" label="创建时间" v-if="getIsView()">
                <el-input disabled v-model="form.createdTime"></el-input>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="purchaseApplyNo" label="请领单号" v-if="getIsView()">
                <el-input disabled v-model="form.purchaseApplyNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>请领单号:{{ form.purchaseApplyNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyDeptName" label="请领科室" v-if="getIsView()">
                <el-input disabled v-model="form.applyDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>请领科室:{{ form.applyDeptName }} </span>
            </el-col>
          </el-row>

        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">拣货情况</span>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="需拣货明细" name="first">
              <el-table ref="childTable" border :data="form.toPickDetails" style="width: auto; margin: 0 10px"
                max-height="600" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column prop="productName" label="产品名称" min-width="180" fixed="left"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specName" fixed="left" label="规格型号"
                  width="180"></el-table-column>
                <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
                <el-table-column prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
                <el-table-column prop="toPickNumber" label="需拣数量" width="120"></el-table-column>
                <el-table-column prop="pickedNumber" label="已拣数量" width="120"></el-table-column>
                <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
                <el-table-column prop="supplierName" label="供应商" width="180"></el-table-column>
                <el-table-column min-width="160" label="完成情况">
                  <template slot-scope="scope">
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(
                      scope.row.pickedNumber,
                      scope.row.toPickNumber
                    )
                      " color="#42b983" />
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="已拣货明细" name="second">
              <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
                max-height="600" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column prop="productName" label="产品名称" width="180" fixed="left"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specName" fixed="left" label="产品规格"
                  width="180"></el-table-column>
                <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
                <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
                <el-table-column prop="number" label="拣货数量" width="120"></el-table-column>
                <el-table-column prop="price" label="采购价" width="120"></el-table-column>

                <el-table-column prop="batch" label="批次号" width="120"></el-table-column>
                <el-table-column prop="serialNo" label="序列号" width="120"></el-table-column>
                <el-table-column prop="manufactureDate" label="生产日期" width="150">
                  <template slot-scope="scope">
                    {{
                      scope.row.manufactureDate
                        ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="validityDate" label="有效期" width="150">
                  <template slot-scope="scope">
                    {{
                      scope.row.validityDate
                        ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="longTime" label="是否长期" width="100">
                  <template slot-scope="scope">
                    {{ scope.row.longTime == 1 ? "是" : "否" }}
                  </template>
                </el-table-column>
                <el-table-column prop="locationName" label="货位" width="180"></el-table-column>
                <el-table-column prop="supplierName" label="供应商" width="180"></el-table-column>
                <el-table-column show-overflow-tooltip prop="mainNo" width="160" label="主条码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="traceNo" width="160" label="溯源码"></el-table-column>
                <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.hasTagCode == 1" v-preventReClick class="color-blue"
                      @click="tagCodeView(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <!-- <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
        @click="proTemSave">暂 存</my-button> -->
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData"
      @tagCodeDelete="tagCodeDelete" @close="closeLabelDetailsDialog" />
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
      @viewDetails="viewDetails" @tagCodeDelete="tagCodeDelete" @close="closePackageLabelDialog" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetPurchaseApplyById,
  SavePickingStock,
  GetPickingStockById,
  RejectPickingStock,
} from "@/api";
import {
  InStockOptions,
  AssetSourceOptions,
  PurchaseApplyCategoryOptions,
  OrderPressingOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog
  },
  data() {
    return {
      form: {},
      InStockOptions: InStockOptions,
      AssetSourceOptions: AssetSourceOptions,
      PurchaseApplyCategoryOptions: PurchaseApplyCategoryOptions,
      OrderPressingOptions: OrderPressingOptions,
      reject:RejectPickingStock,
      activeName: 'first',
      showWorkFlowInfo: false,
      editMode:false
    };
  },

   created() {
    let query = this.$route.query;
    if (query.pickingIds) {
      let ids = query.pickingIds.split(';')
     ids.forEach((item,index) => {
          this.getAdd(item,index);
      });
    } else {
      this.getView(query.id);
    }
  },
  
  methods: {


    
    // 新增合并方法
    mergeToPickDetails() {
      console.log(this.form.toPickDetails);
      
      if (!this.form.toPickDetails || this.form.toPickDetails.length <= 1) {
        return; // 无需合并
      }
      
      // 使用Map来跟踪相同supplierProductNo的项
      const mergedMap = new Map();
      
      this.form.toPickDetails.forEach(item => {
        const key = item.supplierProductNo;
        if (mergedMap.has(key)) {
          // 如果已存在相同的supplierProductNo，累加toPickNumber
          const existingItem = mergedMap.get(key);
          existingItem.toPickNumber += item.toPickNumber;
        } else {
          // 如果是新的supplierProductNo，添加到Map中
          mergedMap.set(key, { ...item });
        }
      });
      
      // 将Map转换回数组
      this.form.toPickDetails = Array.from(mergedMap.values())
      console.log(this.form.toPickDetails);
      
      // 强制更新视图
      this.$forceUpdate();
    },
    
    handleClick() {
      if (this.activeName == 'first') {

      }
    },
    getAdd(id,index) {
      GetPurchaseApplyById({
        id
      }).then(res => {
        // this.form = res.returnData;
        this.$nextTick(()=>{

          this.form.no = ''
          this.form.purchaseApplyNo =this.form.purchaseApplyNo?this.form.purchaseApplyNo+';'+res.returnData.no:res.returnData.no
          this.form.applyDeptName = res.returnData.applyDeptName
          this.form.applyDeptId = res.returnData.applyDeptId
          let ids = this.$route.query.ids.split(';')
          this.form.warehouseName = res.returnData.oneLevelWarehouseName
          this.form.warehouseId = res.returnData.oneLevelWarehouseId
          this.form.createdUserName = this.userInfo.name,
          this.form.createdTime = this.parseTime(new Date()),
          this.initWorkFlowProperty(this.form);
          // notReceivedNumber 未接收数量 pickedNumber 已接收数量
          if(this.form.toPickDetails?.length>0){
            this.form.toPickDetails = this.form.toPickDetails.concat(res.returnData.details.filter(item => {
            return ids.includes(item.id.toString());
          }))
          }else{
              this.form.toPickDetails = res.returnData.details.filter(item => {
            return ids.includes(item.id.toString());
          });
          }
          
          this.form.toPickDetails.forEach(item => {
            item.toPickNumber = item.number - item.pickedNumber
            item.pickedNumber = 0
          })
          if(index==ids.length-1){
            this.mergeToPickDetails()
          }
        })
       this.$forceUpdate();

      })
    },
    getView(id) {
      GetPickingStockById({
        id
      }).then(res => {
        this.form = res.returnData;
        this.form.createdTime = this.parseTime(new Date(this.form.createdTime))
         this.initWorkFlowProperty(this.form);
      })
    },
    cancel() {
      this.$store.dispatch('SetLoading', false)
      this.$router.go(-1);
    },
    submit(){
      if(this.$route.query.formMode==1){
        // let arr = [this.$route.query.pickingId].concat(this.$route.query.ids.split(';'))
        // this.form.applyStockAndDetailIds = arr.join(';')
        this.form.applyStockIds = this.$route.query.pickingIds
        this.form.applyStockDetailIds = this.$route.query.ids
      }
      this.form.orgCode = sessionStorage.getItem('orgId');
      SavePickingStock(this.form).then(res=>{
          sessionStorage.setItem("editMode", 0);
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

.el-tabs {
  padding: 10px 5px;
}

.el-tab-pane {
  padding: 10px 0;
}
</style>